var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          disabled: !_vm.canChangeBrand,
                          label: _vm.$ct("ctep-brand-id"),
                          fancy: "",
                          items: _vm.brandItems,
                        },
                        model: {
                          value: _vm.setting.PaymentType,
                          callback: function ($$v) {
                            _vm.$set(_vm.setting, "PaymentType", $$v)
                          },
                          expression: "setting.PaymentType",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-select-bank-type", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("bank"),
                          "use-ids": "",
                        },
                        model: {
                          value: _vm.setting.BankTypeID,
                          callback: function ($$v) {
                            _vm.$set(_vm.setting, "BankTypeID", $$v)
                          },
                          expression: "setting.BankTypeID",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { disabled: !_vm.canSave, icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }